import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo, useState } from 'react';
import { View } from 'react-native';

/**
 * A screen of `maxWidth` (or the window, if narrower), outlined, with a
 * page's padding inside: its content is laid out against the measured
 * width, as on that screen.
 */
export const PreviewFrame = memo(
  ({
    maxWidth,
    children,
  }: {
    maxWidth: number;
    children: (width: number) => ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    const [width, setWidth] = useState(0);
    const [screen, setScreen] = useState(0);
    return (
      <View
        onLayout={event => setScreen(event.nativeEvent.layout.width)}
        style={{
          width: '100%',
          maxWidth,
          alignSelf: 'center',
          gap: rpx(8),
          padding: rpx(16),
          borderWidth: 1,
          borderStyle: 'dashed',
          borderColor: '#CBD5E1',
          borderRadius: rpx(12),
        }}
      >
        <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
          {screen ? `屏幕宽度 ${Math.round(screen)}px` : ' '}
        </Typography.Text>
        <View onLayout={event => setWidth(event.nativeEvent.layout.width)}>
          {width ? children(width) : null}
        </View>
      </View>
    );
  },
);
